import React from 'react';
import { ICON } from 'resources/constants';
import {
  Wrapper,
  Button,
  ButtonText,
  Image,
  KnowledgeWrapper,
  KnowledgeIcon,
} from './elements';
import { getTagInfoColors, getTagImage } from 'utils/challenge';
import { useConfig, useImage } from 'common/hooks';

type Props = {
  readonly className?: string;
  readonly text: string;
  readonly tag: string;
  readonly onClick: () => void;
  readonly isCompleted: boolean;
};

function QuizCategory({
  className,
  text,
  tag,
  onClick,
  isCompleted,
}: Props): React.ReactElement {
  const { staticUrl } = useConfig();
  const colors = getTagInfoColors(tag);
  const image = getTagImage(staticUrl, tag);
  const [imageUrl] = useImage(image.small);

  return (
    <Wrapper
      className={className}
      onClick={onClick}
      color={colors.quaternary}
      isCompleted={isCompleted}
    >
      <KnowledgeWrapper color={isCompleted ? '#FBC02D' : colors.secondary}>
        <KnowledgeIcon color={'#fff'} icon={ICON.school} />
      </KnowledgeWrapper>
      {image.small === imageUrl && (
        <Image
          src={imageUrl}
          hasExtraBottomMargin={tag === 'energy'}
          isCompleted={isCompleted}
        />
      )}
      <Button>
        <ButtonText>{text}</ButtonText>
      </Button>
    </Wrapper>
  );
}

export default QuizCategory;
